<div [formGroup]="parts" *ngIf="isReady">

<input  class="{{_class}}" type="text"   matInput   formControlName="selectedId" [matAutocomplete]="vendorAutoComplete">

<mat-autocomplete #vendorAutoComplete="matAutocomplete" [displayWith]="displayItemFn">
  <mat-option *ngFor="let item of itemOptions | async; trackBy: trackByFn" [value]="item">
    {{ item.name }}
  </mat-option>
</mat-autocomplete>

</div>